$('.faq .panel-title a').on('click', function () {
    var self = $(this);
    var accordion = self.parents('.panel-group');
    var panelHeading = self.parents('.panel-heading');

    // toggle heading
    accordion.find('.panel-heading').not(panelHeading).removeClass('active');
    panelHeading.toggleClass('active');

    // toggle content
    var content = panelHeading.siblings('.panel-collapse');
    content.toggleClass('collapse');
    $('div.accordion').find('.panel-collapse').not(content).addClass('collapse');

});


$('.faq .category').on('change', function () {
    $(this).parents('form').submit();
});